var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"odr-short",class:( _obj = {
         'odr-short_less': _vm.less,
         'odr-short_more': _vm.more
     }, _obj[("odr-short_background-" + _vm.color)] = true, _obj ),style:(("max-width: " + _vm.width + " !important; max-height: " + _vm.eHeight + " !important"))},[_c('div',{ref:"content",staticClass:"odr-short__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }